export default [
    {
        path: '/admin/users',
        name: 'admin.users',
        component: () => import('./UsersManagementPage.vue'),
        meta: {
            requiresAuth: true,
            requiresSysAdmin: true
        }
    }
];
